import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { SAVE_LEVEL } from '../../../../constants/Level';
import ThirdpartyLeaveModal from '../common/ThirdpartyLeaveModal';
import { withRouter } from 'react-router';

import ManageDomains from './ManageDomains';
import './styles.scss';

const Index = ({ chainId, hotelId, hotelName, level, route, router, isError, isLoading, inContextBeta }) => {
    const canShowModal = !isError && !isLoading;

    return (
        <div>
            <p className="normal-text information">
                for <strong>Chain {chainId}</strong>
                {level === SAVE_LEVEL.HOTEL && (
                    <span>
                        {' '}
                        | <strong>Hotel {hotelId}</strong> {hotelName}
                    </span>
                )}
            </p>
            <div className={inContextBeta ? "" : "spark-panel spark-mar-t-1"}>
                <div className="spark-panel__content">
                    <ManageDomains />
                    <ThirdpartyLeaveModal route={route} router={router} canShowModal={canShowModal} />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    chainId: state.app.selected.chain.Id,
    hotelId: state.app.selected.selectedHotel.id,
    hotelName: state.app.selected.selectedHotel.name,
    level: state.app.selected.level,
    isLoading: get(state, 'app.data.thirdparty.isLoading', true),
    isError: get(state, 'app.data.thirdparty.isError', false),
    inContextBeta: get(state, 'app.selected.inContextBeta')
});

export default connect(mapStateToProps, null)(withRouter(Index));



// WEBPACK FOOTER //
// ./src/components/pages/manage/domains/index.js